import {AssuranceBDL} from '../bdl/assurance';

export const AssuranceServices = () => ({...AssuranceBDL()});
